<template>
  <div class="products-result-base" :style="styles">
    <div class="header-area">
      <h1>MITSURI<br>暴露数鑑定書</h1><span class="subtitle">仕事について</span>
      <!-- ↑副題のところ以外は画像(svg)で良いと思う -->
      <img class="line" src="/static/img/recommend/lp/houen/products/creamline.png">
    </div>
    <div class="result-base">
      <result-bakuro-num-b
        v-if="!!resultData && Object.keys(resultData).length > 0"
        :title-str="titleStr"
        :birth-str="userBirthdate"
        :result-data="resultData"
      />
      <regist-birthdate v-else :csrf-token="csrfToken" reg-btn-face="占う" />
    </div>
    <div class="block-regist-info" v-if="!!resultData && Object.keys(resultData).length > 0">
      <img class="line-top" src="/static/img/recommend/lp/houen/products/whiteline_top.png">
      <regist-birthdate  :csrf-token="csrfToken" header-word="他の誕生日で占う" reg-btn-face="占う" />
      <img class="line-bottom" src="/static/img/recommend/lp/houen/products/whiteline_bottom.png">
    </div>
    <section class="link-box">
      <p class="title">その他の状況を占う</p>
        <div class="block-other-appraisal">
          <a href="/products/45/0002/result">恋愛について</a>
          <a href="/products/45/0001/result">あなたの本質について</a>
          <a href="/products/45/0009/result">あなたの対人運と人間関係</a>
          <a href="/products/45/0010/result">あなたの結婚運命と異性運</a>
        </div>
    </section>
    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import ResultBakuroNumB from "./ResultBakuroNumB";
import RegistBirthdate from "../partials/RegistBirthdate";
import BannerBlock from '../partials/BannerBlock';
import SimpleLinkMenuBlock from '../partials/SimpleLinkMenuBlock';
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsResult02',
  components: {
    RecommendBlockPlus,
    ResultBakuroNumB,
    RegistBirthdate,
    BannerBlock,
    SimpleLinkMenuBlock,
  },
  props: {
    resultData: {
      //type: Object,
      type: [Object, Array],
      default: null,
    },
    pageId: {
      type: String,
      required: true,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      selectedItem: 0,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.user,
      userProf: state => state.account.profile,
      subscInfo: state => state.account.subscription
    }),
    titleStr(){
      return this.pageId === '0002'
        ? '恋愛をするときは<br>暴露数__num__のあなたが主役'
        : '仕事をするときは<br>暴露数__num__のあなたが主役'
    },
    userBirthdate(){
      // if(!!this.userProf){
        const year = +this.resultData.birthday.substring(0, 4);
        const month = +this.resultData.birthday.substring(4, 6);
        const day = +this.resultData.birthday.substring(6);
        return `${year}年${month}月${day}日`
      // }
      // return ''
    },
    counselorInfos(){
      return BASIC_DATA.houen
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {},
  methods: {
    onHeadItemClick(idx){
      if(!this.isSame && this.selectedItem !== idx) {
        this.panelSwiper.slideTo(idx, 300)
        this.selectedItem = idx
      }
    },
    onSlideChange(){
      this.selectedItem = this.panelSwiper.activeIndex
    }
  },
}</script>

<style scoped lang='scss'>
  @import "../../../../../../sass/commons/commonVariables.scss";
  @import "../../../../../../sass/commons/styles/fonts";

$title-fontfamily:'Hiragino Mincho Pro';
$main-green:#00462E;
$uranai-black: #32373F;
$houen-blue:#3A89C9;
.products-result-base {
  .regist-birthdate{
    background: #fff;
    border-radius: 0px;
  }
  .header-area{
    background-size: contain;
    background-image: url(/static/img/recommend/lp/houen/products/bk_result.png);
    background-repeat-y: repeat;
    padding: 40px 20px 0;
    .line{
      width: 100vw;
      height: auto;
      margin-bottom: -3px;
      margin: 0 calc(50% - 50vw);
      margin-bottom: -3px;

      @include mq('w580'){
        width: 580px;
        height: auto;
        margin: 0;
        margin-bottom: -5px;
        margin-left: -20px;
        }

    }
    h1{
      @extend .source-han-serif-bold;
      //font-style: normal;
      //font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      //font-family: $title-fontfamily;
      border-bottom:1px solid $main-green ;
      margin: 0 auto 10px;
      text-align: center;
      display: block;
      width: 180px;
      color: $main-green;
      letter-spacing: 6px;
      padding-bottom: 10px;
    }
    img{
      width:130px;
      height: 130px;
      margin: auto;
      display: block;
    }
    p{
      //font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: $uranai-black;
      margin-bottom: 40px;
    }
    .lead-text{
      @extend .source-han-serif-bold;
      //font-family: $title-fontfamily;
      //font-style: normal;
      //font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      letter-spacing: 1px;
      color: $main-green;
      margin: 0;
      margin-bottom: 40px;
    }
  }
  .result-base {
    .result-body {
      .birthdate {}
      h3 {}
      .result-head {
        .head-item {
          transition: all 300ms ease-out 0s;
          filter: alpha(0.2);
          cursor: pointer;
          user-select: none;
          img {
            border: 1px solid blue;
            display: block;
            min-height: 30px;
          }
          &.selected {
            filter: none;
            border: 1px solid red;
          }
        }
        &.is-same {
          .head-item {
            filter: none;
            cursor: default;
            &.selected {
              border: none;
            }
          }
        }
      }
    }
  }
}

.block-regist-info{
    position: relative;
    background: #f8f5ed;
    .line-top{
      position: absolute;
      top: -13px;
      height: auto;
      width: 100%;
    }
    .line-bottom{
      width: 100%;
      height: auto;
      position: absolute;
      bottom: -12px;
    }
  }
.subtitle {
  @extend .source-han-serif-bold;
  //font-style: normal;
  //font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 4px;
  margin-bottom: 24px;
  color: $main-green;
  //font-family: $title-fontfamily;
  display: block;
}

.link-box{
  padding-top:40px;
  padding-bottom: 60px;
  background-size: contain;
  background-image: url(/static/img/recommend/lp/houen/products/bk_result.png);
  background-repeat-y: repeat;
  }
.block-foot-message{
  display: flex;
  padding-top: 40px;
  img{
    width:128px;
    height: 142px;
    margin-right:16px;
    margin-bottom: 16px;
  }
  p{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-right: 20px;
  }
}
.block-other-appraisal{
  margin: 0 20px;
  border: 1px solid $uranai-black;
  a{
    padding: 20px;
    position: relative;
    text-decoration: none;
    display: block;
    border-bottom:1px solid  #dadada;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    background: #fff;
    &:after{
      content:'';
      border-top:2px solid $houen-blue;
      border-right:2px solid $houen-blue;
      position: absolute;
      width: 10px;
      height: 10px;
      right: 30px;
      top: 43%;
      transform: rotate(45deg);
    }
  }
}
.title{
  font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color:$main-green;
  text-align: center;
  margin: 0;
  margin-bottom: 24px;
}


/deep/{
  .block-banners img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/fortunes/ProductsResult03.vue